import { render } from "./selectCustom.vue?vue&type=template&id=0a40fd38&scoped=true"
import script from "./selectCustom.vue?vue&type=script&lang=js"
export * from "./selectCustom.vue?vue&type=script&lang=js"

import "./selectCustom.vue?vue&type=style&index=0&id=0a40fd38&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a40fd38"]])

export default __exports__